import React from 'react';
import { Modal } from 'react-bootstrap';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CloseIcon from '@material-ui/icons/Close';
import './MessageToast.css';

// Shared success/error notification -- a colored pill with an icon and an X
// close button, replacing the old "Message" modal (title + body + OK button)
// used throughout the app. `type` is 'success' (green) or 'error' (red).
const MessageToast = ({ show, type = 'success', message, onClose }) => {
    const isSuccess = type !== 'error';
    const lines = Array.isArray(message) ? message : [message];

    return (
        <Modal show={!!show} onHide={onClose} centered backdrop="static" contentClassName="message-toast-content">
            <div className={`message-toast message-toast--${isSuccess ? 'success' : 'error'}`}>
                {isSuccess ? <CheckCircleOutlineIcon className="message-toast__icon" /> : <HighlightOffIcon className="message-toast__icon" />}
                <div className="message-toast__text">
                    {lines.map((line, idx) => <div key={idx}>{line}</div>)}
                </div>
                <CloseIcon className="message-toast__close" onClick={onClose} />
            </div>
        </Modal>
    );
};

export default MessageToast;
